import common from './common.json';
import landing from './landing.json';
import home from './home.json';
import course from './course.json';

const en = {
  ...common,
  ...landing,
  ...home,
  ...course,
};

export default en;
